<template>
    <Loader />
    <Nav />
    <div id="myTabContent">
      <div id="profile" role="tabpanel" aria-labelledby="profile-tab">
        <Header/>
        <main class="p-0.5 grid grid-cols-1">
          <Projects/>
          <Skills/>
          <Contact/>
          <Notifs/>
          <Footer/>
        </main>
      </div>
      <Cv />
    </div>
    <div class="cursor cursor-shadow"></div>
    <div class="cursor cursor-dot"></div>
</template>

<script>
import $ from "jquery";
import * as emailjs from "@emailjs/browser";
import "vue-skeletor/dist/vue-skeletor.css";
import Nav from "@/components/Nav";
import Header from "@/components/Header";
import Projects from "@/sections/Projects";
import Skills from "@/sections/Skills";
import Contact from "@/sections/Contact";
import Notifs from "@/components/Notifs";
import Footer from "@/components/Footer";
import Cv from "@/Pages/Cv";
import Loader from "@/components/Loader";

  export default {
    name: 'App',
    components: {Loader, Cv, Footer, Notifs, Contact, Skills, Projects, Header, Nav},

    mounted() {
      emailjs.init('e4YYQN2T-e8_vwdDC');

      const SendEmail = document.getElementById('sendMail');

      document.getElementById('MailForm')
          .addEventListener('submit', function(event) {
            event.preventDefault();

            SendEmail.value = 'Sending...';

            const MailNotif = document.getElementById('MailNotif');

            const serviceID = 'default_service';
            const templateID = 'template_1x7pn8q';

            emailjs.sendForm(serviceID, templateID, this)
                .then(() => {
                  SendEmail.value = 'Send Email';
                  MailNotif.innerHTML = `
                      <div id="toast-simple" class="flex items-center w-full max-w-xs p-4 space-x-4 text-gray-500 bg-white divide-x divide-gray-200 rounded-lg shadow dark:text-gray-400 dark:divide-gray-700 space-x dark:bg-gray-800" role="alert">
                          <svg class="w-5 h-5 text-blue-600 dark:text-blue-500" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="paper-plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.6 36.86l-64 415.1c-1.5 9.734-7.375 18.22-15.97 23.05c-4.844 2.719-10.27 4.097-15.68 4.097c-4.188 0-8.319-.8154-12.29-2.472l-122.6-51.1l-50.86 76.29C226.3 508.5 219.8 512 212.8 512C201.3 512 192 502.7 192 491.2v-96.18c0-7.115 2.372-14.03 6.742-19.64L416 96l-293.7 264.3L19.69 317.5C8.438 312.8 .8125 302.2 .0625 289.1s5.469-23.72 16.06-29.77l448-255.1c10.69-6.109 23.88-5.547 34 1.406S513.5 24.72 511.6 36.86z"></path></svg>
                          <div class="pl-4 text-sm font-normal">Message sent successfully.</div>
                      </div>`;
                  setTimeout(() => {
                    MailNotif.innerHTML = '';
                  }, 5000);
                }, (err) => {
                  SendEmail.value = 'Send Email';
                  alert(JSON.stringify(err));
                });
          });
      // Initialize CV Page
      let CV = document.getElementById('CV');

      let Makecv = document.getElementById('updatepage');

      Makecv.addEventListener('click', function() {
        CV.innerHTML = `<h1 class="typewriter" id="cvtext">The CV</h1>`;
        CV.innerHTML += `<div class="flex justify-center" style="position: relative; width: 100%; height: 0; padding-top: 141.4286%;
 padding-bottom: 48px; box-shadow: 0 2px 8px 0 rgba(63,69,81,0.16); margin-top: 1.6em; margin-bottom: 0.9em; overflow: hidden;
 border-radius: 8px; will-change: transform;">
  <iframe loading="lazy" style=" position: absolute; width: 80%; height: 80%; top: 0; left: 10%; border-radius: 10px; padding: 0;margin: 0;"
    src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFBIspgP54&#x2F;view?embed" allowfullscreen="allowfullscreen" allow="fullscreen">
  </iframe>
</div>`;
      } , false);


      // Remove CV part after click home
      // let HomeBtn = document.querySelector('.HomeBtn');
      //
      //
      // HomeBtn.addEventListener('click', function() {
      //   window.location.reload();
      // })

      // Option
      // detect selection of text
      // function selection() {
      //   let selection = window.getSelection();
      //   if (selection.toString().length > 0) {
      //     console.log(selection.toString());
      //   }
      // }
      //
      // window.addEventListener('click', selection);

//

function typeWriter() {
  let word = document.getElementById("Load");
  let i = 0;
  let txt = 'LOADING...';
  let speed = 150;
  let typeWriter = setInterval(function () {
    if (i < txt.length) {
      word.innerText += txt.charAt(i);
      i++;
    } else {
      clearInterval(typeWriter);
    }
  }, speed);
}

function clearText() {
  let word = document.getElementById('Load');
  word.innerText = '';
}


// repeat animation  every 2 seconds  and clear text

setInterval(function () {
  clearText();
  typeWriter();
} , 2500);

// Make a wordBank and create loop to change word every second
let wordBank = ['HTML', 'CSS', 'JS', 'ReactJS', 'PHP', 'Symfony'];
let i = 0;
let speed = 2500;

setInterval(function () {
  let word = document.getElementById('word');
  word.innerText = wordBank[i];
  i++;
  if (i > wordBank.length - 1) {
    i = 0;
  }
} , speed);

let closeSkills = document.getElementById('closebtn');

closeSkills.addEventListener('click', function() {
  const MailNotif = document.getElementById('MailNotif');

  MailNotif.innerHTML =
      `
      <div id="toast-danger" class="flex items-center p-4 mb-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800" role="alert">
          <div class="inline-flex flex-shrink-0 justify-center items-center w-8 h-8 text-red-500 bg-red-100 rounded-lg dark:bg-red-800 dark:text-red-200">
              <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
              <span class="sr-only">Error icon</span>
          </div>
          <div class="ml-3 text-sm font-normal">Tu ne peux pas faire ca !</div>
          <button type="button" class="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700" data-dismiss-target="#toast-danger" aria-label="Close">
              <span class="sr-only">Close</span>
              <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
          </button>
      </div>`;
 setTimeout(() => {
    MailNotif.innerHTML = '';
  }, 5000);

} , false);


// detect window white mode
      function whiteMode() {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          console.log('dark mode');
        }
        else {
          console.log('light mode');
        }
      }

      window.addEventListener('load', whiteMode);

// disable right click if adress is not localhost
      function disableRightClick() {
        if (window.location.hostname !== 'localhost') {
          document.addEventListener('contextmenu', function(e) {
            e.preventDefault();
          }, false);
        }
      }

      window.addEventListener('load', disableRightClick);

// disable drag and drop
      function disableDrag() {
        document.addEventListener('dragstart', function(e) {
          e.preventDefault();
        } , false);
      }

      window.addEventListener('load', disableDrag);

// disable copy paste
      function disableCopyPaste() {
        document.addEventListener('copy', function(e) {
          e.preventDefault();
        } , false);
      }

      window.addEventListener('load', disableCopyPaste);

// disable F12 key if not localhost
      function disableF12() {
        if (window.location.hostname !== 'localhost') {
          document.addEventListener('keydown', function(e) {  // keydown event
            if (e.keyCode === 123) { // if F12
              e.preventDefault();
              alert('F12 is disabled');
            }   // prevent default action
          } , false);
        }
      }

      window.addEventListener('load', disableF12);

      // end of option
      $(window).mousemove(function(e) {
        $(".cursor").css({
          left: e.pageX,
          top: e.pageY
        })
      });
      $(".cursor-link")
          .on("mouseenter", function() {
            $('.cursor').addClass("active")
          })
          .on("mouseleave", function() {
            $('.cursor').removeClass("active")
          });
      if (window.matchMedia('min-width: 600px').matches) {
        $('.cursor-dot').css('display', 'none');
        $('.cursor-shadow').css('display', 'none');
        $('.cursor').css('display', 'none');
      }
      $(window).on('load', function() {
          $('body').addClass("dark");
          console.log('dark mode');
      });
    }


  }
</script>


<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

body{
  font-family: Helvetica, sans-serif;
  background: #0d1117;
  overflow-x: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #f8f8f8;
}

#Brand{
  font-size: 2em;
  font-weight: bold;
  color: #f8f8f8;
  text-decoration: none;
  margin-bottom: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  border-radius: 3px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  stroke: #6366f1;
}

#ProfileCard{
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/pat.svg);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 300%;
  position: absolute;
}

#BGCard{
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/pat.svg);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 300%;
}

#dropdownInformation{
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/pat.svg);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 300%;
}

.codepen-hover{
  fill: white;
}

.cursor-link
{
  cursor: pointer;
}

@media (min-width: 640px) {
  .Responsive
  {
    min-height: 50vh;
  }
}

@media (min-width: 1280px) {
  .Responsive
  {
    min-height: 50vh;
  }
}

/* #Cursor
================================================== */

@media (min-width: 640px) {
  * {
    cursor: none;
  }
  svg:hover {
    cursor: pointer;
  }
  .cursor {
    --size: 8px;
    height: var(--size);
    width:  var(--size);
    border-radius: 50%;
    position: absolute;
    z-index: 10000;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }
  .cursor.cursor-shadow {
    background-color: transparent;
    border: 1px solid #fff;
    --size: 40px;
    transition: top .2s, left .2s,
    width .2s, height .2s,
    background-color .2s, border-color 0.2s;
    transition-timing-function: ease-out;
  }
  .cursor.cursor-dot {
    background: #6366f1;
    transition: width .2s, height .2s;
  }
  .cursor-shadow.active {
    --size: 80px;
    border-color: rgba(255,255,255, 0);
    background-color: rgba(255,255,255,.1);
  }
  .cursor-dot.active {
    --size: 0;
  }
}



::selection {
  background: #5b5fdc;
}

/* Animations Text
 ================================================== */

.typewriter h1 {
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: .15em solid orange; /* The typwriter cursor */
  white-space: nowrap; /* Keeps the content on a single line */
  margin: 0 auto; /* Gives that scrolling effect as the typing happens */
  letter-spacing: .15em; /* Adjust as needed */
  animation:
      typing 3.5s steps(40, end),
      blink-caret .75s step-end infinite;
}

/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange; }
}
.loaded
{
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #ADAFB6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(249, 251, 255,0.6);
}

*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.Background-container{
  width: 100%;
  padding: 40px 30px;
  border: 2px solid rgba(255,255,255,0.06);
  border-radius: 10px;
  box-shadow: 0 20px 30px rgba(0,0,0,0.2);
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/pat.svg);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 300%;
}
.Background-container *{
  font-family: "Poppins",sans-serif;
  color: #ffffff;
  font-weight: 500;
}
h2{
  margin-bottom: 40px;
  letter-spacing: 2px;
}
.skills:not(:last-child){
  margin-bottom: 30px;
}
.details{
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.bar{
  position: relative;
  background-color: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.06);
  padding: 7px 10px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}
.bar div{
  position: relative;
  width: 0;
  height: 5px;
  border-radius: 10px;
  background-color: #6366f1;
  border: 1px solid#6366f1;
  box-shadow: 0 0 5px rgba(28,151,252,0.6);
}



#jQuery-bar{
  animation: jQuery-fill 3.5s infinite;
}
@keyframes jQuery-fill{
  from{
    width: 0;
  }
  to{
    width: 100%;
  }
}


.Responsive
{
  min-height: 50vh;
}


.boxes {
  height: 32px;
  width: 32px;
  position: relative;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  margin-top: 32px;
  -webkit-transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
}
.boxes .box {
  width: 32px;
  height: 32px;
  top: 0px;
  left: 0;
  position: absolute;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}



.boxes .box:nth-child(1) {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
  -webkit-animation: box1 1s linear infinite;
  animation: box1 1s linear infinite;
}
.boxes .box:nth-child(2) {
  -webkit-transform: translate(0, 100%);
  transform: translate(0, 100%);
  -webkit-animation: box2 1s linear infinite;
  animation: box2 1s linear infinite;
}
.boxes .box:nth-child(3) {
  -webkit-transform: translate(100%, 100%);
  transform: translate(100%, 100%);
  -webkit-animation: box3 1s linear infinite;
  animation: box3 1s linear infinite;
}
.boxes .box:nth-child(4) {
  -webkit-transform: translate(200%, 0);
  transform: translate(200%, 0);
  -webkit-animation: box4 1s linear infinite;
  animation: box4 1s linear infinite;
}



.boxes .box > div {
  background: #5C8DF6;
  --translateZ: 15.5px;
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #5C8DF6;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  -webkit-transform: rotateY(var(--rotateY)) rotateX(var(--rotateX)) translateZ(var(--translateZ));
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX)) translateZ(var(--translateZ));
}

.boxes .box > div:nth-child(1) {
  top: 0;
  left: 0;
  background: #5C8DF6;
}
.boxes .box > div:nth-child(2) {
  background: #145af2;
  right: 0;
  --rotateY: 90deg;
}
.boxes .box > div:nth-child(3) {
  background: #447cf5;
  --rotateX: -90deg;
}
.boxes .box > div:nth-child(4) {
  background: #DBE3F4;
  top: 0;
  left: 0;
  --translateZ: -90px;
}


@keyframes box1 {
  0%,
  50% {
    transform: translate(100%, 0);
  }
  100% {
    transform: translate(200%, 0);
  }
}

@keyframes box2 {
  0%{
    transform: translate(0, 100%);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
}

@keyframes box3 {
  0%,
  50% {
    transform: translate(100%, 100%);
  }
  100% {
    transform: translate(0, 100%);
  }
}

@keyframes box4 {
  0%{
    transform: translate(200%, 0);
  }
  50% {
    transform: translate(200%, 100%);
  }
  100% {
    transform: translate(100%, 100%);
  }
}

/*  Loader Part */
:root {
  --secondary-color: #003140;
  --hue: 223;
  --bg: hsl(var(--hue),10%,10%);
  --fg: hsl(var(--hue),10%,90%);
  font-size: calc(16px + (24 - 16) * (100vw - 320px) / (1280 - 320));
}

.pl__ring {
  stroke: hsla(var(--hue),10%,90%,0.1);
}

.pl,
.pl__worm {
  animation-duration: 3s;
  animation-iteration-count: infinite;
}
.pl {
  animation-name: bump;
  animation-timing-function: linear;
  width: 8em;
  height: 8em;
}

.pl__worm {
  animation-name: worm;
  animation-timing-function: cubic-bezier(0.42,0.17,0.75,0.83);
}

.wrapper {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: var(--bg);
  color: var(--fg);
  font: 1em/1.5 sans-serif;
  display: grid;
  place-items: center;
  transition: opacity 0.25s, visibility 1s, background-color 0.3s;
}

.wrapper.fade {
  opacity: 0;
  visibility: hidden;
}

/* Animations */
@keyframes bump {
  from,
  42%,
  46%,
  51%,
  55%,
  59%,
  63%,
  67%,
  71%,
  74%,
  78%,
  81%,
  85%,
  88%,
  92%,
  to { transform: translate(0,0); }
  44% { transform: translate(1.33%,6.75%); }
  53% { transform: translate(-16.67%,-0.54%); }
  61% { transform: translate(3.66%,-2.46%); }
  69% { transform: translate(-0.59%,15.27%); }
  76% { transform: translate(-1.92%,-4.68%); }
  83% { transform: translate(9.38%,0.96%); }
  90% { transform: translate(-4.55%,1.98%); }
}
@keyframes worm {
  from { stroke-dashoffset: 10; }
  25% { stroke-dashoffset: 295; }
  to { stroke-dashoffset: 1165; }
}

/*  End Of Loader Part */
</style>

